import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    // Grid,
    IconButton,
    Button,
    Tooltip,
    // ButtonGroup,
    // Grow,
    // Paper,
    // Popper,
    // MenuItem,
    // MenuList,
    // ClickAwayListener
} from '@material-ui/core';
// import { ArrowDropDown } from '@material-ui/icons';

/**
 * @description 圖標按鈕
 * @param {boolean} disableRipple 禁用按鈕漣漪效果 
 * @param {boolean} disabled 是否禁用按鈕 
 * @param {string} size 大小
 * @param {function} click 按鈕點擊要執行的事件
 * @param {string} color 主顏色
 * @param {string} ariaLabel 按鈕的 aria-label 屬性
 * @param {Component} icon 按鈕圖標
 * @param {string} attribute 屬性
 * @param {string} className className
 * @param {string} tipplacement tip的位置 上:top 右:left 右上: right-start 右下: right-end 左: left 左上: left-start 左下: left-end 下: bottom
 * @param {string} tiptitle tip的內容
 */
class ReactIconBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <>
                {this.props.tiptitle !== undefined ? // 要不要有 tooltip
                    <Tooltip className={this.props.className} data-aria={this.props.aria} placement={this.props.tipplacement} title={this.props.tiptitle} arrow={this.props.tiparrow}>
                        <IconButton style={this.props.style} attribute={this.props.attribute} disabled={this.props.disabled} ref={this.props.ref}
                            size={this.props.size === undefined ? "small" : this.props.size} onClick={this.props.click}
                            onChange={this.props.change} disableRipple={this.props.disableRipple} color={this.props.color}
                            aria-label={this.props.ariaLabel} component="span">
                            {this.props.icon}
                        </IconButton>
                    </Tooltip>
                    : <IconButton className={this.props.className} style={this.props.style} attribute={this.props.attribute} disabled={this.props.disabled}
                        size={this.props.size === undefined ? "small" : this.props.size} onClick={this.props.click} ref={this.props.ref}
                        onChange={this.props.change} disableRipple={this.props.disableRipple} color={this.props.color} onMouseEnter={this.props.mouseEnter} onMouseLeave={this.props.mouseLeave}
                        aria-label={this.props.ariaLabel} component="span">
                        {this.props.icon}
                    </IconButton>
                }
            </>
        );
    }
}
/**
 * ReactIconBtn
 * @description 型別判斷
 */
ReactIconBtn.propTypes = {
    disableRipple: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.string,
    click: PropTypes.func,
    color: PropTypes.string,
    ariaLabel: PropTypes.string,
    icon: PropTypes.element,
    ref: PropTypes.object,
    mouseEnter: PropTypes.func,
    mouseLeave: PropTypes.func,
}
/**
 * @description 文字按鈕
 * @param {boolean} disableRipple 禁用按鈕漣漪效果 
 * @param {boolean} disabled 是否禁用按鈕
 * @param {string} size table 大小
 * @param {function} click 按鈕點擊要執行的事件
 * @param {string} color 主顏色
 * @param {string} ariaLabel 按鈕的 aria-label
 * @param {string} attribute 屬性
 * @param {boolean} fullWidth 滿寬
 * @param {string} text 按鈕文字
 */
class ReactTextBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <div style={{ margin: "0.3rem", maxHeight: '150px', }}>
                <Button disabled={this.props.disabled}
                    fullWidth={this.props.fullWidth}
                    onClick={this.props.click}
                    attribute={this.props.attribute}
                    disableRipple={this.props.disableRipple}
                    variant={this.props.variant === undefined ? "contained" : this.props.variant}
                    color={this.props.color === undefined ? "primary" : this.props.color}
                    size={this.props.size}
                    style={this.props.style}
                >
                    {this.props.text}
                </Button>
            </div>
        );
    }
}
/**
 * ReactTextBtn
 * @description 型別判斷
 */
ReactTextBtn.propTypes = {
    disableRipple: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.string,
    click: PropTypes.func,
    color: PropTypes.string,
    ariaLabel: PropTypes.string,
    text: PropTypes.string,
}
/**
 * @description  圖標 + 文字按鈕
 * @param {boolean} disableRipple 禁用按鈕漣漪效果 
 * @param {boolean} disabled 是否禁用按鈕
 * @param {string} size 大小
 * @param {function} click 按鈕點擊要執行的事件
 * @param {string} color 主顏色
 * @param {string} ariaLabel 按鈕的 aria-label
 * @param {component} icon 按鈕圖標
 * @param {string} text 按鈕文字
 * @param {string} attribute 屬性
 * @param {boolean} fullWidth 滿寬
 * @param {string} variant 樣式 contained | outlined
 * 
 */
class ReactIconTextBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <div style={this.props.style === undefined ? { margin: "0.3rem", maxHeight: '150px', } : this.props.style}>
                <Button className={this.props.className} disabled={this.props.disabled} onClick={this.props.click}
                    component={this.props.component}
                    fullWidth={this.props.fullWidth}
                    attribute={this.props.attribute}
                    disableRipple={this.props.disableRipple}
                    variant={this.props.variant === undefined ? "contained" : this.props.variant}
                    size={this.props.size} color={this.props.color} startIcon={this.props.icon}>
                    {this.props.text}
                </Button>
            </div>
        );
    }
}
/**
 * ReactIconTextBtn
 * @description 型別判斷
 */
ReactIconTextBtn.propTypes = {
    disableRipple: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.string,
    click: PropTypes.func,
    color: PropTypes.string,
    ariaLabel: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.element,
}

// function SplitButton(props) {
//     const [open, setOpen] = React.useState(false);
//     const anchorRef = React.useRef(null);
//     const [selectedIndex, setSelectedIndex] = React.useState(1);

//     const handleClick = () => {
//         console.info(`You clicked ${props.tabsData[selectedIndex]}`);
//     };

//     const handleMenuItemClick = (event, index) => {
//         setSelectedIndex(index);
//         setOpen(false);
//     };

//     const handleToggle = () => {
//         setOpen((prevOpen) => !prevOpen);
//     };

//     const handleClose = (event) => {
//         if (anchorRef.current && anchorRef.current.contains(event.target)) {
//             return;
//         }

//         setOpen(false);
//     };

//     return (
//         <React.Fragment>
//             <ButtonGroup variant="contained" color={props.color} ref={anchorRef} aria-label="split button" 
//             disableElevation={props.disableElevation} disableRipple={props.disableRipple}>
//                 <Button onClick={handleClick}>{props.tabsData[selectedIndex]}</Button>
//                 <Button
//                     color={props.color}
//                     size={props.size}
//                     aria-controls={open ? props.id : undefined}
//                     aria-expanded={open ? 'true' : undefined}
//                     aria-label="select merge strategy"
//                     aria-haspopup="menu"
//                     onClick={handleToggle}>
//                     <ArrowDropDown />
//                 </Button>
//             </ButtonGroup>
//             <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
//                 {({ TransitionProps, placement }) => (
//                     <Grow
//                         {...TransitionProps}
//                         style={{
//                             transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
//                         }}
//                     >
//                         <Paper>
//                             <ClickAwayListener onClickAway={handleClose}>
//                                 <MenuList id={props.id}>
//                                     {props.tabsData.map((item, index) => (
//                                         <MenuItem
//                                             key={index}
//                                             disabled={index === 2}
//                                             selected={index === selectedIndex}
//                                             onClick={(event) => handleMenuItemClick(event, index)}>
//                                             {item}
//                                         </MenuItem>
//                                     ))}
//                                 </MenuList>
//                             </ClickAwayListener>
//                         </Paper>
//                     </Grow>
//                 )}
//             </Popper>
//         </React.Fragment>
//     );
// }


export {
    ReactIconBtn,
    ReactTextBtn,
    ReactIconTextBtn,
    // SplitButton
};